import {
  ActionType,
  IPatientRegistrationPayload,
  IPatientRegistrationResponse,
} from "models/setting/patientRegistration";

export const registerPatientAction = (payload: IPatientRegistrationPayload) => {
  return {
    type: ActionType.PATIENT_REGISTRATION,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.PATIENT_REGISTRATION_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IPatientRegistrationResponse) => {
  return {
    type: ActionType.PATIENT_REGISTRATION_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.PATIENT_REGISTRATION_RESET,
  };
};
